export const onClickParent = ({ path, navigate, children }) => {
  if (children?.length > 0) return;

  navigate(`${path}`);
};
